module.exports = __webpack_public_path__ + "static/media/laxmirajmokuf2.676bf2d1.png";